import axios from 'axios';
import store from './redux/store/store';
import { SIGN_OUT_SUCCESS } from './redux/actions/actionTypes';

let redirectScheduled = false;

function isAuthLoginOrRegisterRequest(url) {
  if (!url || typeof url !== 'string') return false;
  const u = url.toLowerCase();
  return u.includes('/auth/loginuser') || u.includes('/auth/registeruser');
}

axios.interceptors.response.use(
  (response) => response,
  (error) => {
    const status = error.response?.status;
    if (status !== 401 || error.config?.skipAuthRedirect) {
      return Promise.reject(error);
    }
    const requestUrl = error.config?.url || '';
    if (isAuthLoginOrRegisterRequest(requestUrl)) {
      return Promise.reject(error);
    }
    if (!redirectScheduled) {
      redirectScheduled = true;
      localStorage.removeItem('userData');
      store.dispatch({ type: SIGN_OUT_SUCCESS });
      window.location.assign(`${window.location.origin}/auth`);
    }
    return Promise.reject(error);
  }
);
